import React, { useState } from "react";
import { Wallet } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import BudgetExpensesPanel, { BUDGET_EXPENSE_STATUSES } from "@/components/BudgetExpensesPanel";
import FinanceResultDialog from "@/components/FinanceResultDialog";

// Lançar gastos do orçamento direto da lista, sem abrir o orçamento.
export default function QuickExpenseButton({ budget }) {
  const [open, setOpen] = useState(false);
  const [resultOpen, setResultOpen] = useState(false);
  if (budget.parent_budget_id || !BUDGET_EXPENSE_STATUSES.includes(budget.status)) return null;
  return (
    <>
      <Button
        variant="outline"
        onClick={() => setOpen(true)}
        className="w-full rounded-xl h-10 border-rose-200 text-rose-700 hover:bg-rose-50 bg-white"
        data-testid={`btn-quick-expense-${budget.number}`}
      >
        <Wallet className="w-4 h-4 mr-2" />
        Lançar gasto
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto overflow-x-hidden w-[calc(100vw-1.5rem)] sm:w-full grid-cols-1 [&>*]:min-w-0" data-testid="quick-expense-dialog">
          <DialogHeader className="text-left">
            <DialogTitle className="text-base text-[#1e3a8a] leading-snug pr-6 break-words" data-testid="quick-expense-school">
              {budget.school_name || ""}
            </DialogTitle>
            <p className="text-xs font-semibold text-slate-500" data-testid="quick-expense-number">Gastos · Orçamento Nº {budget.number}</p>
          </DialogHeader>
          {open && <BudgetExpensesPanel budget={budget} canAdd onOpenResult={() => setResultOpen(true)} />}
        </DialogContent>
      </Dialog>
      <FinanceResultDialog open={resultOpen} onOpenChange={setResultOpen} budgetId={budget.id} />
    </>
  );
}
